import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import "./report.css";
import { useReactToPrint } from 'react-to-print';
import print from "print-js";
import {Link} from "react-router-dom";
import {  NEW_PRINT } from "../config/config";
import Multiselect from 'multiselect-react-dropdown';
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

// Let's add a fetchData method to our Table component that will be used to fetch
// new data when pagination state changes
// We can also add a loading state to let our table know it's loading new data
function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
}) {
    const count = preFilteredRows.length;

    return (
        <input
            value={filterValue || ""}
            className="form-control"
            onChange={(e) => {
                setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
            }}
            placeholder={`Search ${count} records...`}
        />
    );
}

const formatDateSlash = (dateInp) => {
    try{
    let date = dateInp;
    date = new Date(date).toISOString();
    date = date.split("T")[0];
    date = date.split("-").reverse().join("/");
    return date;
    }
    catch(error){
    return dateInp
    }
};

const ReportTable = React.forwardRef(({
    columns,
    data,
    extraData,
    onSort,
    fetchData,
    dateObject,
    loading,
    pageCount: controlledPageCount,
    canView,
    handleViewClick,
    checkbox,
    handleCheckboxChange,
    checkedList,
    isChecked,
    getSelectAllValue,
    handleSelectAll,
    handleDeselectAll,
    title,
    dateState,
    extraPrint,
    formName,
    enableColumnDragDrop = false,
    columnOrderStorageKey,
    onColumnReorder,
    totalAmount,
}, ref) => {
    const companyId = JSON.parse(sessionStorage.getItem("company_id"))?.company_id ?? "1";
    const fYear_fetch = JSON.parse(sessionStorage.getItem("financial_year_for_fetch")).financial_year_for_fetch;
    
    const [checked,setChecked] = useState(false);     // checkbox for in transit


    let initialCustomFilter = {}
    if(title != "Company Master Report"){
        initialCustomFilter = { 
            companyId: "" + companyId,
            fyear: fYear_fetch,  
        }
    }

    const [customFilters, setCustomFilters] = React.useState(initialCustomFilter);

    // const [customFilters, setCustomFilters] = React.useState({
    //     companyId: "" + companyId,
    //     fyear: fYear_fetch,   
    // });

    let [updatedCustomFilters, setUpdatedCustomFilters] = React.useState({
        companyId: "" + companyId,
        fyear: fYear_fetch,  
        "in_transit": null, 
    });

    React.useEffect(()=> {
        if(title == "EwbExtensionReport") {
            setCustomFilters(customFilters => ({
                ...customFilters,
                ...updatedCustomFilters
            }));
        }
    },[])

    const [highlightRow, setHighlightRow] = React.useState([]);

    const filterTypes = React.useMemo(
        () => ({
            // Add a new fuzzyTextFilterFn filter type.
            // Or, override the default text filter to use
            // "startWith"
            text: (rows, id, filterValue) => {
                return rows.filter((row) => {
                    const rowValue = row.values[id];
                    return rowValue !== undefined
                        ? String(rowValue)
                            .toLowerCase()
                            .startsWith(String(filterValue).toLowerCase())
                        : true;
                });
            },
        }),
        []
    );
    const defaultColumn = React.useMemo(
        () => ({
            // Let's set up our default Filter UI
            Filter: DefaultColumnFilter,
        }),
        []
    );
    const getColumnKey = React.useCallback((column, index) => {
        if (column?.id) {
            return String(column.id);
        }
        if (typeof column?.accessor === "string") {
            return column.accessor;
        }
        if (typeof column?.Header === "string") {
            return column.Header;
        }
        return `column-${index}`;
    }, []);

    const allColumnKeys = useMemo(
        () => columns.map((column, index) => getColumnKey(column, index)),
        [columns, getColumnKey]
    );

    const getInitialOrderedColumns = React.useCallback(() => {
        if (!enableColumnDragDrop) {
            return columns;
        }

        let savedColumnOrder = [];
        if (columnOrderStorageKey) {
            try {
                const parsedOrder = JSON.parse(localStorage.getItem(columnOrderStorageKey) || "[]");
                if (Array.isArray(parsedOrder)) {
                    savedColumnOrder = parsedOrder;
                }
            } catch (error) {
                savedColumnOrder = [];
            }
        }

        const finalColumnOrder = [
            ...savedColumnOrder.filter((key) => allColumnKeys.includes(key)),
            ...allColumnKeys.filter((key) => !savedColumnOrder.includes(key)),
        ];

        return finalColumnOrder
            .map((key) => {
                const columnIndex = allColumnKeys.indexOf(key);
                return columnIndex > -1 ? columns[columnIndex] : null;
            })
            .filter(Boolean);
    }, [allColumnKeys, columnOrderStorageKey, columns, enableColumnDragDrop]);

    const [orderedColumns, setOrderedColumns] = useState(() => getInitialOrderedColumns());

    useEffect(() => {
        setOrderedColumns(getInitialOrderedColumns());
    }, [getInitialOrderedColumns]);

    const activeColumns = enableColumnDragDrop ? orderedColumns : columns;

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        // Get the state from the instance
        state: { pageIndex, pageSize, sortBy },
    } = useTable(
        {
            columns: activeColumns,
            data,
            initialState: { pageIndex: 0 },
            defaultColumn, // Pass our hoisted table state
            manualPagination: true, // Tell the usePagination
            // hook that we'll handle our own data fetching
            // This means we'll also have to provide our own
            // pageCount.
            manualSortBy: true,
            autoResetPage: false,
            autoResetSortBy: false,
            pageCount: controlledPageCount,
            initialState: { pageSize: 100 }
            //   autoResetFilters: false
        },
        // useFilters,
        useSortBy,
        usePagination
    );
    // Listen for changes in pagination and use the state to fetch our new data
    React.useEffect(() => {
        fetchData({ pageIndex, pageSize, sortBy, customFilters, dateObject });
    }, [fetchData, pageIndex, pageSize, sortBy, customFilters, dateObject]);


    // *********CODE FOR TRANSIT BUTTON*******
    const handleTransit = () => {
        // let sortBy = [{"in_transit": 1}];
        setChecked(!checked);
        if(checked == false) {
            customFilters.in_transit = 1;
            fetchData({ pageIndex, pageSize, sortBy, customFilters, dateObject });
        }
        else {
            customFilters.in_transit = null;
            fetchData({ pageIndex, pageSize, sortBy, customFilters, dateObject });
        }
    }
    // ******END************

    const updateFilters = (e) => {
        let { name, value } = e.target;
        gotoPage(0)
        setCustomFilters({ ...customFilters, [name]: value });
    };


    const [multiStationObject, setMultiStationObject] = React.useState({
        multi_to_station : [],
        multi_from_station : []
    });

    var fromstation;
    var  toStation;

    const updateFilters2 = (e, name) => {
        let multi_station = []
        console.log("values_inisde", e)
        let value;
        for (let i = 0; i < e.length; i++) {
            value = e[i];
            multi_station.push(value);
        }
        console.log("MULTI", multi_station);
        if (name == "station_to_name") {
            setMultiStationObject({ ...multiStationObject, multi_to_station: multi_station })
        }
        if (name == "station_from_name") {
            setMultiStationObject({ ...multiStationObject, multi_from_station: multi_station })
        }
        // gotoPage(0)
    }

    const updateSelectAll = (name) => {
        let multi_station = []
        let value;
        for (let i = 0; i < toStation.length; i++) {
            value = toStation[i];
            multi_station.push(value);
        }
        if (name == "station_to_name") {
            if (multiStationObject.multi_to_station.length != toStation.length){
                multi_station = toStation;
                console.log("MULTI", multi_station);
                setMultiStationObject({ ...multiStationObject, multi_to_station: multi_station })
            }
            else{
                // Deselect operattion
                setMultiStationObject({ ...multiStationObject, multi_to_station: [] })
            }
        }
        if (name == "station_from_name") {
            if (multiStationObject.multi_from_station.length != fromstation.length){
                multi_station = fromstation;
                console.log("MULTI", multi_station);
                setMultiStationObject({ ...multiStationObject, multi_from_station: multi_station })
            }
            else{
                // Deselect operattion
                setMultiStationObject({ ...multiStationObject, multi_from_station: [] })
            }
        }
        gotoPage(0)
    }
    const applyMultiStationFilter = (name) => {
        if (name == "station_to_name") {
            setCustomFilters({ ...customFilters, multi_to_station: multiStationObject.multi_to_station })
        }
        if (name == "station_from_name") {
            setCustomFilters({ ...customFilters, multi_from_station: multiStationObject.multi_from_station })
        }
        gotoPage(0)
    }

    function arraysEqual(a1,a2) {
        /* WARNING: arrays must not contain {objects} or behavior may be undefined */
        return JSON.stringify(a1)==JSON.stringify(a2);
    }

    const renderGoButton = (columnName)=>{
        console.log("rendergo", columnName, customFilters, multiStationObject)
        if (columnName == "station_from_name"){
            return (!arraysEqual(customFilters.multi_from_station, multiStationObject.multi_from_station)) ?
            <button onClick={()=>applyMultiStationFilter("station_from_name")} style={{marginBottom : '3px', margin: '2px'}}>
            Go
            </button>
            :
            <></>
        }
        else{
            return (!arraysEqual(customFilters.multi_to_station, multiStationObject.multi_to_station)) ?
            <button onClick={()=>applyMultiStationFilter("station_to_name")} style={{marginBottom : '3px', margin: '2px'}} >
            Go
            </button>
            :
            <></>
        }
    }
    
    if(localStorage.getItem('fromCities') == [] || localStorage.getItem('toCities') == []) {
        console.log("inside..");
        fromstation = [];
        toStation = [];
    }
    else {
        console.log("inside get..");
        fromstation = JSON.parse(localStorage.getItem('fromCities'));
        toStation = JSON.parse(localStorage.getItem('toCities'));
        console.log("RESP",fromstation,toStation);
    }


    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });
    
    const executeServerPrint = async (fileName) => {
        let date_from = formatDateSlash(dateObject.date_from);
        let date_to = formatDateSlash(dateObject.date_to);
        
        let cash_total = 0;
        let cheque_total = 0;
        let credit_total = 0;
        let nill_total = 0;
        let updatedData = data;

        let extraDataObject = {
            client_name: process.env.REACT_APP_CLIENT_NAME_FOR_BILTY_PRINT,
            file_name: fileName,
            date_from: date_from,
            date_to: date_to,
        };
        
        if (formName === "biltyReport") {
            updatedData = data.map(item => {
                let updatedItem = { ...item };
                if (item.mr_type === "Cash") {
                    cash_total += Number(item.total_amount);
                } else if (item.mr_type === "Cheque") {
                    cheque_total += Number(item.total_amount);
                } else if (item.mr_type === "Credit") {
                    credit_total += Number(item.total_amount);
                } else if (item.mr_type === "Nill") {
                    nill_total += Number(item.total_amount);
                }
        
                if (item.pay_type == 1) {
                    updatedItem.print_to_pay = Number(item.total_amount);
                    updatedItem.print_paid = 0;
                    updatedItem.print_foc = 0;
                    updatedItem.print_tbb = 0;
                } else if (item.pay_type == 2) {
                    updatedItem.print_paid = Number(item.total_amount);
                    updatedItem.print_to_pay = 0;
                    updatedItem.print_foc = 0;
                    updatedItem.print_tbb = 0;
                } else if (item.pay_type == 3) {
                    updatedItem.print_foc = Number(item.total_amount);
                    updatedItem.print_to_pay = 0;
                    updatedItem.print_paid = 0;
                    updatedItem.print_tbb = 0;
                } else if (item.pay_type == 4) {
                    updatedItem.print_tbb = Number(item.total_amount);
                    updatedItem.print_to_pay = 0;
                    updatedItem.print_paid = 0;
                    updatedItem.print_foc = 0;
                }

                return updatedItem;
            });
        }

        if (formName === "biltyReport") {
            let grand_total =
            process.env.REACT_APP_CLIENT === "guru"
            ? totalAmount
            : cash_total + cheque_total + credit_total + nill_total;
            
            let total_mr = data.length;
            extraDataObject = {
                ...extraDataObject,
                file_name: fileName == undefined ? "biltyreportamount" : fileName,
                cash_total: cash_total,
                cheque_total: cheque_total,
                credit_total: credit_total,
                nill_total: nill_total,
                grand_total: grand_total,
                total_mr: total_mr,
            };
        }

        if (formName === "challanReport") {

            let tripAmountTotal = 0;
            let pfTotal = 0;

            updatedData = data.map(item => {
                let updatedItem = { ...item };
                
                if (process.env.REACT_APP_CLIENT === "nrab" || process.env.REACT_APP_CLIENT === "syt" || process.env.REACT_APP_CLIENT === "sangam") {
                    updatedItem.lorry_hire = item.lorry_hire == null ? 0 : item.lorry_hire;
                }
                if (process.env.REACT_APP_CLIENT === "guru") {
                    updatedItem.trip_total_amount = (Number(item.trip_amount) || 0) + (Number(item.trip_labour) || 0) + (Number(item.trip_other) || 0);
                }

                // Add to grand total
                tripAmountTotal += Number(updatedItem.trip_total_amount || 0);
                pfTotal += Number(updatedItem.pf || 0);

                return updatedItem;
            });

            extraDataObject = {
                ...extraDataObject,
                file_name: "mainchallan",
                vehicle_no: data[0].vehicle_no,
                station_from_name: data[0].station_from_name,
                driver_name: data[0].driver_name,
                booking_chalan_date: data[0].booking_chalan_date,
                phone_no: data[0].phone_no,
                to_pay_total: extraData[0].total,
                paid_total: extraData[1].total,
                tbb_total: extraData[2].total,
                ...(process.env.REACT_APP_CLIENT === "guru" && { trip_amount_total: extraData[3].total, pf_total: extraData[4].total, }),
            };
        }

        if(formName === "freightReport") {
            extraDataObject = {
                ...extraDataObject,
                party_name: data?.[0]?.party_name || "",
                gst_no: data?.[0]?.gst_no || "",
            };
        }

        let url = NEW_PRINT + "/bilty/print_table/";


        let payload = {
            data: updatedData,
            ...extraDataObject
        };

        let response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload),
        }).then((r) => r.blob());

        print({
            printable: URL.createObjectURL(response),
            type: "pdf",
            showModal: false,
        });
    };
    
    const [tableWidth, setTableWidth] = useState('1000px');

    const tooglehighlightRow = (rowId) => {
        let hlRow = [...highlightRow];
        const idx = hlRow.indexOf(rowId);
        if(idx > -1) {
            hlRow.splice(idx, 1);
            setHighlightRow(hlRow);
        }
        else {
            hlRow.push(rowId);
            setHighlightRow(hlRow);
        }
    }

    useEffect(() => {
        var wrapper1 = document.getElementById('wrapper1');
        var wrapper2 = document.getElementById('wrapper2');

        wrapper1.onscroll = function () {
            wrapper2.scrollLeft = wrapper1.scrollLeft;
        };
        wrapper2.onscroll = function () {
            wrapper1.scrollLeft = wrapper2.scrollLeft;
        };

        let tableWidthCurr = componentRef.current.offsetWidth + "px";

        setTableWidth(tableWidthCurr);
    }, [])

    const handleColumnDragEnd = (result) => {
        if (!enableColumnDragDrop || !result.destination) {
            return;
        }

        if (result.destination.index === result.source.index) {
            return;
        }

        const updatedColumns = Array.from(orderedColumns);
        const [movedColumn] = updatedColumns.splice(result.source.index, 1);
        updatedColumns.splice(result.destination.index, 0, movedColumn);
        setOrderedColumns(updatedColumns);
        if (onColumnReorder) {
            onColumnReorder(updatedColumns);
        }

        if (columnOrderStorageKey) {
            const updatedColumnOrder = updatedColumns.map((column, index) =>
                getColumnKey(column, index)
            );
            localStorage.setItem(columnOrderStorageKey, JSON.stringify(updatedColumnOrder));
        }
    };

    const renderColumnFilter = (column) => {
        return (column.id == "station_to_name" || column.id == "station_from_name") 
            && formName === "challanReport" 
            && ["avr", "sgtc", "jtsa", "std", "nptc", "bgtc", "ase", "arbuda", "bbac"].includes(process.env.REACT_APP_CLIENT) ?
            <div>
                {renderGoButton(column.id)}
                <button onClick={()=>updateSelectAll(column.id)}>all</button>
                <Multiselect
                    isObject={false}
                    options={
                        column.id === "station_to_name" 
                            ? (toStation || []).map((branch) => branch) 
                            : (fromstation || []).map((branch) => branch)
                    }
                    onRemove={(e) => { updateFilters2(e, column.id) }}
                    onSelect={(e) => { updateFilters2(e, column.id) }}
                    selectedValues={column.id == "station_to_name" ? multiStationObject.multi_to_station : multiStationObject.multi_from_station}
                    placeholder={`Select records...`}
                    showCheckbox
                    style={{ width: column.width, minWidth: column.minWidth }}
                />
            </div>
            :
            <div>
                <input
                    name={column.id}
                    value={customFilters[column.id]}
                    className="form-control-input"
                    onChange={updateFilters}
                    placeholder={`Search records...`}
                    style={{ width: column.width, minWidth: column.minWidth }}
                />
            </div>;
    };

    const renderHeaderLabel = (column, dragHandleProps) => {
        const headerLabel = (
                                            <div
                                                {...dragProvided.dragHandleProps}
                                                style={{ cursor: enableColumnDragDrop ? "grab" : "default" }}
                                            >
                                            <div
                                                {...dragProvided.dragHandleProps}
                                                style={{ cursor: enableColumnDragDrop ? "grab" : "default" }}
                                            >
                                                <span {...column.getSortByToggleProps({
                                                    style: {
                                                        minWidth: column.minWidth,
                                                        width: column.width,
                                                    },
                                                })}>
                                                    {column.render("Header")}
                                                    {column.isSorted
                                                        ? column.isSortedDesc
                                                            ? " DESC"
                                                            : " ASC"
                                                        : ""}
                                                </span>
                                            </div>
                                            </div>
        );

        if (!dragHandleProps) {
            return headerLabel;
        }

        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                }}
            >
                <span
                    {...dragHandleProps}
                    style={{
                        cursor: "grab",
                        userSelect: "none",
                        fontWeight: "bold",
                    }}
                >
                    ::
                </span>
                {headerLabel}
            </div>
        );
    };


    // Render the UI for your table
    return (
        <>
            <div className="report-container">

            {/* CODE FOR TRANSIT CHECKBOX */}
            {title == "EwbExtensionReport" ? 
            <label>
                <input 
                    type="checkbox"
                    defaultChecked={checked} 
                    onChange={handleTransit}
                /> 
                In Transit ?
            </label>
            : 
            <div></div> }

                <DragDropContext onDragEnd={handleColumnDragEnd}>
                <div id="wrapper1">
                    <div className="div1" style={{ width: `${tableWidth}` }}>
                    </div>
                </div>
                <div id="wrapper2" >
                    <table {...getTableProps()} className="div2" ref={componentRef}>
                        <thead >
                            {headerGroups.map((headerGroup) => (
                                <Droppable
                                    droppableId={`table-headers-${headerGroup.id}`}
                                    direction="horizontal"
                                    key={headerGroup.id}
                                >
                                {(provided) => (
                                <tr
                                    {...headerGroup.getHeaderGroupProps()}
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                >
                                    {
                                        canView && <div></div>
                                    }
                                    {
                                        checkbox && <input 
                                            type="checkbox"
                                            name="main_checkbox"
                                            value={getSelectAllValue()}
                                            onChange={(e) => {
                                                if(getSelectAllValue()) {
                                                    handleDeselectAll();
                                                }
                                                else {
                                                    handleSelectAll();
                                                }
                                            }}
                                        />
                                    }
                                    {headerGroup.headers.map((column, index) => (
                                        <Draggable
                                            key={getColumnKey(column, index)}
                                            draggableId={getColumnKey(column, index)}
                                            index={index}
                                            isDragDisabled={!enableColumnDragDrop}
                                        >
                                        {(dragProvided, snapshot) => (
                                        <th
                                            {...column.getHeaderProps({
                                                style: {
                                                    minWidth: column.minWidth,
                                                    width: column.width,
                                                    whiteSpace: "nowrap",
                                                    backgroundColor: snapshot.isDragging ? "#e3f2fd" : undefined
                                                },
                                            })}
                                            ref={dragProvided.innerRef}
                                            {...dragProvided.draggableProps}
                                        >

                                            <div
                                                {...dragProvided.dragHandleProps}
                                                style={{ cursor: enableColumnDragDrop ? "grab" : "default" }}
                                            >
                                            <span {...column.getSortByToggleProps({
                                                style: {
                                                    minWidth: column.minWidth,
                                                    width: column.width,
                                                },
                                            })}>
                                                {column.render("Header")}
                                                {column.isSorted
                                                    ? column.isSortedDesc
                                                        ? " 🔽"
                                                        : " 🔼"
                                                    : ""}
                                            </span>
                                            </div>

                                            { (column.id == "station_to_name" || column.id == "station_from_name") 
                                                && formName === "challanReport" 
                                                && ["avr", "sgtc", "jtsa", "std", "nptc", "bgtc", "ase", "arbuda", "bbac"].includes(process.env.REACT_APP_CLIENT) ?
                                                <div>
                                                    {renderGoButton(column.id)
                                                    }
                                                    <button onClick={()=>updateSelectAll(column.id)}>all</button>
                                                    <Multiselect
                                                        isObject={false}
                                                        options={
                                                            column.id === "station_to_name" 
                                                                ? (toStation || []).map((branch) => branch) 
                                                                : (fromstation || []).map((branch) => branch)
                                                        }
                                                        onRemove={(e) => { updateFilters2(e, column.id) }}
                                                        onSelect={(e) => { updateFilters2(e, column.id) }}
                                                        selectedValues={column.id == "station_to_name" ? multiStationObject.multi_to_station : multiStationObject.multi_from_station}
                                                        // onChange={updateFilters}
                                                        placeholder={`Select records...`}
                                                        showCheckbox
                                                        style={{ width: column.width, minWidth: column.minWidth }}
                                                    />
                                                </div>
                                                :
                                                <div>
                                                    {<input
                                                        name={column.id}
                                                        value={customFilters[column.id]}
                                                        className="form-control-input"
                                                        onChange={updateFilters}
                                                        placeholder={`Search records...`}
                                                        style={{ width: column.width, minWidth: column.minWidth }}
                                                    />}

                                                </div>
                                            }


                                            {/* <div>
                                                {column.accessor && column.canFilter ? <input
                                                    name={column.id}
                                                    value={customFilters[column.id]}
                                                    className="form-control"
                                                    onChange={updateFilters}
                                                    placeholder={`Search records...`}
                                                    style={{ width: column.width, minWidth: column.minWidth }}
                                                /> : null}

                                            </div> */}

                                            {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
                                        </th>
                                        )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </tr>
                                )}
                                </Droppable>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, i) => {
                                prepareRow(row);
                                const currentRowId = row.cells[0].value;
                                const highlightCurrentRow = highlightRow.indexOf(currentRowId) > -1;
                                const isGrandTotalRow =
                                    ["bgtc", "ase"].includes(process.env.REACT_APP_CLIENT) &&
                                    String(row.cells?.[0]?.value || "").toLowerCase().includes("grand");
                                return (
                                    
                                    <tr
                                        {...row.getRowProps()}
                                        className="report-cell-tr"
                                        style={isGrandTotalRow ? { fontWeight: "bold" } : {}}
                                    >
                                        {
                                            checkbox && <input 
                                                type="checkbox"
                                                checked={isChecked(row.cells)}
                                                onChange={(e) => {
                                                    handleCheckboxChange(row.cells);
                                                }}
                                            />
                                        }
                                        {
                                            canView && <button onClick={() => handleViewClick(row.cells)}>
                                                Open
                                            </button>
                                        }
                                        {/* <button onClick={()=> {
                                                window.open(
                                                    URL = "/bilty",
                                                )
                                            }
                                        }  >
                                            Ok  
                                        </button>
                                        <button>
                                        <Link 
                                            to="/bilty" 
                                            target="_blank"
                                        > Link !! </Link>
                                         </button> */}
                                        {row.cells.map((cell) => {
                                            return (
                                                <td
                                                    onDoubleClick={() => tooglehighlightRow(currentRowId)}
                                                    {...cell.getCellProps()}
                                                    style={{
                                                        textDecoration: highlightCurrentRow ? "underline" : "",
                                                        whiteSpace: "nowrap",
                                                        textAlign: "center",
                                                        maxWidth: "0px",
                                                        overflow: "hidden",
                                                        textTransform: "uppercase",
                                                    
                                                    }}>{cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                            <tr>
                                {loading ? (
                                    // Use our custom loading state to show a loading indicator
                                    <td colSpan="10000">Loading...</td>
                                ) : (
                                    <td colSpan="10000">
                                        Showing {page.length} of ~{controlledPageCount * pageSize}{" "}
                                        results
                                    </td>
                                )}
                            </tr>
                        </tbody>
                    </table>
                    {/* 
            Pagination can be built however you'd like. 
            This is just a very basic UI implementation:
        */}
                </div>
                </DragDropContext>
                <div className="pagination">
                        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                            {"<<"}
                        </button>{" "}
                        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
                            {"<"}
                        </button>{" "}
                        <button onClick={() => nextPage()} disabled={!canNextPage}>
                            {">"}
                        </button>{" "}
                        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                            {">>"}
                        </button>{" "}
                        <span>
                            Page{" "}
                            <strong>
                                {pageIndex + 1} of {pageOptions.length}
                            </strong>{" "}
                        </span>
                        <span>
                            | Go to page:{" "}
                            <input
                                type="number"
                                defaultValue={pageIndex + 1}
                                onChange={(e) => {
                                    const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                    gotoPage(page);
                                }}
                                style={{ width: "100px" }}
                            />
                        </span>{" "}
                        <select
                            value={pageSize}
                            onChange={(e) => {
                                setPageSize(Number(e.target.value));
                            }}
                        >
                            {[10, 20, 30, 40, 50, 100].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                    Show {pageSize}
                                </option>
                            ))}
                        </select>

                        <button
                            onClick={() => {
                                if (process.env.REACT_APP_CLIENT === "sra") {
                                    executeServerPrint("biltyreport");
                                } else if (process.env.REACT_APP_CLIENT === "guru") {
                                    const param = formName === "freightReport" ? "freight_bill_report" : "biltyreport";
                                    executeServerPrint(param);
                                } else {
                                    handlePrint();
                                }
                            }}
                        >
                            Print
                        </button>

                        {(process.env.REACT_APP_CLIENT == "guru" || process.env.REACT_APP_CLIENT == "nrab" || process.env.REACT_APP_CLIENT == "syt" || process.env.REACT_APP_CLIENT == "sangam") && extraPrint && <button onClick={() => executeServerPrint()}>{formName == "biltyReport" ? "Print Amount" : formName == "challanReport" ? "Main Challan" : ""}</button>}
                    </div>
            </div>
        </>
    );
})




export default ReportTable;
